module.exports = __webpack_public_path__ + "static/media/1-6.f27c8df9.mp3";